import DotNetObject = DotNet.DotNetObject;
import { InvoiceLineType } from '@crimsontide/core/client/interfaces';

export const InvoiceLineTypeService = (() => {
  let dotNetObj: DotNetObject;
  let cachedInvoiceLineTypes: InvoiceLineType[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getInvoiceLineTypes = async (useCache: boolean = true): Promise<InvoiceLineType[]> => {
    if (useCache && cachedInvoiceLineTypes != null)
      return cachedInvoiceLineTypes;

    if (dotNetObj) {
      cachedInvoiceLineTypes = await dotNetObj.invokeMethodAsync<InvoiceLineType[]>('GetAsync');
      return cachedInvoiceLineTypes;
    } else {
      throw 'Invoice Line Type DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getInvoiceLineTypes,
  };
})();
